var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPublic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z",
    fill: "#1E2B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 15.438a2.26 2.26 0 0 0-1.125-1.934V8.16C25.125 7.844 24.879 7 24 7a.982.982 0 0 0-.703.281l-3.024 2.39C18.797 10.868 16.898 11.5 15 11.5H8.25A2.243 2.243 0 0 0 6 13.75v3.375c0 1.266.984 2.25 2.25 2.25h1.16c-.035.387-.07.773-.07 1.125 0 1.406.316 2.742.914 3.902.176.387.562.598.984.598h2.602c.914 0 1.476-1.02.914-1.758-.563-.773-.914-1.687-.914-2.742 0-.387.07-.738.14-1.125H15c1.898 0 3.797.668 5.273 1.863l3.024 2.39c.176.177.422.247.668.247.879 0 1.125-.773 1.125-1.125v-5.344a2.234 2.234 0 0 0 1.16-1.968zm-3.375 4.992-1.195-.95A10.745 10.745 0 0 0 15 17.125V13.75a10.71 10.71 0 0 0 6.68-2.32l1.195-.95v9.95z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default __webpack_public_path__ + "static/media/public.d8e640280556d30614bf4222e0987d6d.svg";
export { ForwardRef as ReactComponent };